
export class LogHelper {

    public static log(prefix: string, message: string, ...args: any[]): void {
        console.log(LogHelper.getPrefixedMessage(prefix, message), ...args)
    }

    public static warn(prefix: string, message: string, error: string = null): void {
        let str: string = LogHelper.getPrefixedMessage(prefix, message)

        if (error != null) {
            str += `Error: ${error}`
        }

        console.warn(str)
    }

    public static info(prefix: string, message: string): void {
        console.info(LogHelper.getPrefixedMessage(prefix, message))
    }

    public static error(prefix: string, error: string): void {
        console.error(LogHelper.getPrefixedMessage(prefix, error))
    }

    private static getPrefixedMessage(prefix: string, message: string): string {
        return `${prefix} - ${message}`
    }
}